import { useTranslation } from 'react-i18next';
export const ErrorResponse = ({ message }) => {
  const [t] = useTranslation();
  return (
    <section className='message-wrapper'>
      <h3>{message ? message : t('response.error.title')}</h3>
    </section>
  );
};
